// extracted by mini-css-extract-plugin
export default {"strip":"gfII_p","acceptedMethod":"gMg8qK","paymentMethods":"fYZWjw","termHighlight":"F2LrPG","guaranty":"tiLdaf","secured":"XEC8NZ","termDescription":"AKYJBp"};